import React, { useEffect, useState } from "react";
import find from "lodash/find";
import ReactDatePicker from "react-datepicker";
import { User, Calendar, X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../common/Modal/ModalContent";
import moment from "moment";
import api from "../../utils/api";
import close_modal from "./../../assets/ic_close_modal.svg";
import Spinner from "../../common/Spinner/Spinner";

export default function ESPViewAllNotesModal(props) {

  const [auditLog,setAuditLog] = useState();
  const [isLoading, setLoading] = useState(false);
  const [ESPServiceNames,setESPServiceNames] = useState([]);

  useEffect(() => {
    if(props.isOpen)
    {
        if(props.sEmailAddress)
        {
            let tempserviceReqNames=[];
            if(props.serviceNameListESP&&props.serviceNameListESP.length>0)
            {
                 props.serviceNameListESP.map((e) => {
                  tempserviceReqNames.push(e.label);
                });
                setESPServiceNames(tempserviceReqNames);
            }
            else
            {
              setESPServiceNames([]);
            }

            setLoading(true);
            api.getNotesLogByEmailId({email: props.sEmailAddress})
            .then((d) => {
                setAuditLog(d.data);
                let data=d.data;
                setLoading(false);
            });
        }            
    }
    
  }, [props.isOpen]);

      const renderAuditTrail = () => {
        return Object.keys(auditLog).map((key, i) => (
          (ESPServiceNames.length>0 && ESPServiceNames.includes(auditLog[key].ServiceName))||ESPServiceNames.length==0?
            <> 
              <div className="notes-trail-service-text">{`${auditLog[key].ServiceName} (${key}) `}</div>
                {
                  auditLog[key].notes.length>0?
                  (
                    Object.keys(auditLog[key].notes).map((key1, i) => (
                    <div className={`${i%2==0?'notes-trail-box-even':'notes-trail-box-odd'}`} key={i}>              
                      <div className="flex justify-content-between">
                        <small className="notes-trail-text">{auditLog[key].notes[key1].refHH||auditLog[key].notes[key1].reqUser}</small>
                        <small className="notes-trail-text">{moment(auditLog[key].notes[key1].dtCreated).format('lll')}</small>
                      </div>
                      <div className="conv-mt15">
                        <div><small className="notes-trail-text">Notes</small></div>
                        <div className="notes-trail-content-text conv-mt5" style={{whiteSpace: "pre-line"}}>
                          {auditLog[key].notes[key1].sNotesHH||auditLog[key].notes[key1].sNotes}
                        </div>
                        {auditLog[key].notes[key1].sModule?(""):
                        (
                          <>
                            <div className="conv-mt15"><small className="notes-trail-text">Followup Actions</small></div>
                            <div className="notes-trail-content-text conv-mt5" style={{whiteSpace: "pre-line"}}>
                            {auditLog[key].notes[key1].sFollowupAction}
                            </div>
                            <div className="conv-mt15"><small className="notes-trail-text conv-mt15">Follow up on</small></div>
                            <div className="notes-trail-content-text conv-mt5">{auditLog[key].notes[key1].dtFollowupOn?moment(auditLog[key].notes[key1].dtFollowupOn).format('ll'):""}</div>
                          </>
                        )}            
                      </div>
                  </div>
                ))
                ):
                (<div className="notes-trail-box-even">No notes taken</div>)
              }
            </>
          :
          (
            ""
          )
        ))
      }

  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.toggleModal}
      ariaHideApp={false}
    >
      <ModalContent className="notes-trail-modal">
          <div className="modal-header-sp">
          <span className="modal-title">All Notes Trail</span>
            <img
                alt="close"
                id="Close"
                src={close_modal}
                className="close modal-close"
                onClick={props.toggleModal}
            />
          </div>
        
        <div
            className={`modal-body notes-trail-content conv-pl25 conv-pr25 custom-scrollbar ${isLoading && "set-opacity"}`}
        >
            {isLoading && <Spinner className="top"/>}
            <div>                
                {auditLog?renderAuditTrail():<div className="notes-trail-box-even">No notes taken</div>}
            </div>
        </div>
      </ModalContent>
    </Modal>
  );
}